module.exports = __webpack_public_path__ + "7c27e0a1aed7819285bb510e4f21b266.MP3";